import { Button, ButtonSize, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import React, { memo } from "react";

import Trans from "@/components/Trans/Trans";

type EntriesListLoadMoreErrorProps = {
  message: string;
  onRetry?: () => void;
};

function EntriesListLoadMoreError({ message, onRetry }: EntriesListLoadMoreErrorProps) {
  return (
    <div className="flex flex-col items-center gap-3 py-4" data-testid="EntriesListServer-LoadMoreError">
      <Text className="text-gray-11 text-center" variant={TextVariants.LABEL_MEDIUM_REGULAR}>
        {message}
      </Text>
      {onRetry ? (
        <Button variant={ButtonVariant.OUTLINED} size={ButtonSize.MEDIUM} onClick={onRetry} data-testid="EntriesListServer-LoadMoreRetryButton">
          <Trans i18nKey="common:retry" />
        </Button>
      ) : null}
    </div>
  );
}

export default memo(EntriesListLoadMoreError);
